type ProjectedTagProps = {
  children: React.ReactNode;
};

/** Dashed-border pill used for projected/estimated figures (e.g. first-year ROAS). */
export function ProjectedTag({ children }: ProjectedTagProps) {
  return (
    <span className="inline-flex items-center rounded border border-dashed border-[#47477C] px-2.5 py-1 text-xs leading-4 font-normal text-[#757575]">
      {children}
    </span>
  );
}
